import React, { Component } from "react";
import { connect } from "react-redux";
import { EditorState } from "draft-js";
import ReadOnlyEditor from "../CustomRevvEditor/ReadOnlyEditor";
import { setSidePaneDataForPageNo } from "../../actions/QuotationActions/QuotationActions";
import { updateDraggedSection } from "../../actions/DocumentActions";
import EditorActions from "../../actions/EditorActions";

import { getContentStateFromRawSectionData } from "../../utils/components";
import getCompositeDecorator from "../CustomRevvEditor/decorator";

const { initActiveEditor, forceUpdateLocalEditorState } = EditorActions;
class PageNumber extends Component {
  compositeDecorator = getCompositeDecorator();

  state = {
    localEditorState: null,
  };

  _handleEditEditorClick = () => {
    const { section, isLocked } = this.props;
    if (!isLocked) {
      this.props.setSidePaneDataForPageNo({
        isOpen: true,
        sectionData: section,
      });

      this.props.initActiveEditor(
        this.state.localEditorState,
        this.props.section,
        this.props.componentMeta,
      );
    }
  };

  componentDidMount() {
    this._initLocalEditorState();
    this.props.updateDraggedSection(null, null, null, null);
  }

  componentDidUpdate(prevProps) {
    if (!this.props.isComponentActive && prevProps.isComponentActive) {
      this._initLocalEditorState();
    } else if (this.props.forceUpdateEditorConfigs) {
      if (
        this.props.forceUpdateEditorConfigs.componentId ===
        this.props.componentMeta.componentId
      ) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          localEditorState: this.props.forceUpdateEditorConfigs.editorState,
        });
        this.props.forceUpdateLocalEditorState(null);
      }
    } else if (this.props.isComponentActive && !this.props.activeEditorState) {
      this.props.initActiveEditor(
        this.state.localEditorState,
        this.props.section,
        this.props.componentMeta,
      );
    }
  }

  _initLocalEditorState = () => {
    const editorState = this._generateEditorState();
    this.setState({ localEditorState: editorState });
  };

  _generateEditorState = () => {
    const contentState = getContentStateFromRawSectionData(
      this.props.section,
      this.props.mode,
    );
    if (contentState && Object.keys(contentState).length !== 0) {
      const editorState = EditorState.createWithContent(
        contentState,
        this.compositeDecorator,
      );
      return editorState;
    }
    const { editorState } = EditorState.createEmpty(this.compositeDecorator);
    return editorState;
  };

  _getEditorState = () =>
    this.props.isComponentActive && !this.props.section.lock
      ? this.props.activeEditorState
      : this.state.localEditorState;

  render() {
    const { metaData } = this.props;
    let editorState = this._getEditorState();
    if (typeof window === "undefined") {
      editorState = this._generateEditorState();
      return (
        <div className="page-number">
          <ReadOnlyEditor {...this.props} editorState={editorState} />
        </div>
      );
    }
    if (metaData) {
      const { pageStart, pageEnd } = metaData;
      const pageStartText = pageStart ? `${pageStart}` : "1";
      const pageEndText = pageEnd ? `${pageEnd}` : "1000";
      return (
        <div
          className="page-number"
          data-page-start={`${pageStartText}`}
          data-page-end={`${pageEndText}`}>
          <ReadOnlyEditor
            {...this.props}
            editorState={editorState}
            handleClick={this._handleEditEditorClick}
          />
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { document: { meta_data: docMetaData } = {} } = state.DocumentStore;
  const {
    template: { meta_data: tempMetaData },
  } = state.TemplateStore;
  const { activeEditorState, forceUpdateEditorConfigs } = state.EditorStore;
  let metaData;

  if (ownProps.mode === "DOCUMENT") {
    metaData = docMetaData;
  }
  if (ownProps.mode === "TEMPLATE") {
    metaData = tempMetaData;
  }
  return { metaData, activeEditorState, forceUpdateEditorConfigs };
};

const mapDispatchToProps = {
  setSidePaneDataForPageNo,
  updateDraggedSection,
  initActiveEditor,
  forceUpdateLocalEditorState,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageNumber);

// export default PageNumber;
